import Image from 'next/image';
import { Container, Htag, HtagAlign, HtagVariant } from '../../components';
import styles from './logistic-world.module.css';

import earth from '../../public/logistic/earth-min.png';
import People from '../../public/logistic/people.svg';
import Calendar from '../../public/logistic/calendar.svg';
import Earth from '../../public/logistic/earth.svg';

export default function LogisticWorld() {
  return (
    <div className={styles.root}>
      <Container>
        <Htag
          variant={HtagVariant.h2}
          align={HtagAlign.center}
          className={styles.title}
          tag="h2"
        >
          Providing our services throughout the World
        </Htag>
      </Container>
      <div className={styles.wrapper}>
        <Container>
          <div className={styles.row}>
            <Image
              alt="Earth picture"
              width={661}
              height={661}
              src={earth}
              quality={100}
            />
            <ul className={styles.list}>
              <li className={styles.item}>
                <Calendar />
                <div className={styles.item__col}>
                  <h5 className={styles.item__title}>2017</h5>
                  <p className={styles.item__text}>Year of foundation</p>
                </div>
              </li>
              <li className={styles.item}>
                <People />
                <div className={styles.item__col}>
                  <h5 className={styles.item__title}>1.5 m +</h5>
                  <p className={styles.item__text}>Users</p>
                </div>
              </li>
              <li className={styles.item}>
                <Earth />
                <div className={styles.item__col}>
                  <h5 className={styles.item__title}>40+</h5>
                  <p className={styles.item__text}>Countries</p>
                </div>
              </li>
            </ul>
          </div>
        </Container>
      </div>
    </div>
  );
}
